import { LIKELY_RECURRING_CATEGORIES } from "./likelyRecurringCategories";
import messages from "./messages";
import { ISubscriptionPlan } from "@modules/Subscriptions/types";

export const selectDescriptionMessage = ({
  isVisitOffer,
  quarterlyPlan,
  serviceFeeAmountCents,
  taskCategoryId,
}: {
  isVisitOffer: boolean;
  quarterlyPlan: ISubscriptionPlan | undefined;
  serviceFeeAmountCents: number;
  taskCategoryId: number | undefined;
}) => {
  if (isVisitOffer) return messages.formulaPageIntroUncertainVisit;
  if (quarterlyPlan && serviceFeeAmountCents > quarterlyPlan.priceCents) {
    return messages.formulaPageIntroCsfGreaterRt;
  }
  if (
    taskCategoryId !== undefined &&
    LIKELY_RECURRING_CATEGORIES.includes(taskCategoryId)
  ) {
    return messages.formulaPageIntroLikelyRecurrent;
  }
  return messages.formulaPageIntroDefault;
};
